import {
  Button,
  createMuiTheme,
  makeStyles,
  MuiThemeProvider,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import NavDrawer from "./NavDrawer";
import MaterialDatatable from "material-datatable";
import logo from "../assets/images/logo.png";
import { useHistory } from "react-router";
import axios from "axios";
import moment from 'moment'

const SPACED_DATE_FORMAT = "DD MMM YYYY";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    paddingTop: theme.spacing(6),
    boxSizing: "initial",
  },
  main: {
    display: "flex",
    flexWrap: "wrap",
    margin: `${theme.spacing(0)} auto`,
    paddingTop: theme.spacing(4),
    // marginBottom: theme.spacing(4),
    justifyContent: "space-around",
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  addBtn: {
    background: "#FF6B00 !important",
    color: "#fff",
    cursor: "pointer",
    letterSpacing: 2,
    "&:hover": {
      background: "#36567F !important",
    },
  },
  hospitalTitle: {
    fontWeight: 900,
    fontVariant: "small-caps",
    letterSpacing: "2px",
    color: "#FF6B00",
  },
}));

const Hospitals = () => {
  const classes = useStyles();
  const history = useHistory();
  const [hospitalArr, setHospitalArr] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BASE_URL}api/base-hospitals`)
      .then((res) => {
        // console.log(res.data);
        const allHospitals = res.data.hospitals;
        console.log('Hospitals: ', allHospitals);
        setHospitalArr(allHospitals);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const columns = [
    {
      name: "Hospital Name",
      field: "hospitalName",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "Icon",
      field: "hospitialIcon",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <>
              <img src={value.hospitalIcon} width="50" height="50" alt="logo" />
            </>
          );
        },
      },
    },
    {
      name: "Author",
      field: "author",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "Date",
      field: "date",
      options: { filter: true, sort: true, customBodyRender: value =>
          moment(new Date(value.date)).format(SPACED_DATE_FORMAT) },
    },
    {
      name: "Actions",
      field: "action",
      options: {
        customBodyRender: value => {
          return (
            <>
              <Button
                style={{height: "30px"}}
                variant="outlined"
                color="primary"
                onClick={() => {
                  history.push({pathname: "/add-new-hospital", state: value});
                }}
              >
                Edit
              </Button>
            </>
          );
        },
      },
    },
  ];

  const options = {
    filter: false,
    onRowsDelete: (rowsDeleted) => {
      const array = rowsDeleted.data;
      array.forEach(({ rowIndex, dataIndex }) => {
        console.log(rowIndex, dataIndex);
        const hospital_id = hospitalArr[dataIndex]._id;
        console.log("ID IS :", hospital_id);
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}api/base-hospitals/delete-hospital/${hospital_id}`
          )
          .then((res) => {
            console.log("RESPONSE IS", res);
            console.log("Base hospital Successfully deleted");
          });
      });
    },
  };

  const getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MuiTypography: {
          root: {
            fontFamily: "Montserrat !Important",
            color: "#000",
            fontSize: 20,
            fontWeight: 700,
            fontVariant: "small-caps",
            letterSpacing: "2px",
          },
        },
        MuiTableCell: {
          root: {
            fontSize: 16,
            fontVariant: "small-caps",
            fontFamily: "Montserrat !Important",
          },
        },
        MaterialDatatableToolbar: {
          root: {
            fontFamily: "Montserrat !Important",
            background: "#F2F2F2",
          },
        },

        MuiTableHead: {
          root: {
            fontWeight: 700,
            fontSize: 16,
          },
        },
        MaterialDatatableToolbarSelect: {
          deleteIcon: {
            color: "red",
          },
          title: {
            color: "#000 !important",
          },
        },

        MuiIconButton: {
          root: {
            color: "#2B2828",
          },
        },
      },
    });

  return (
    <>
      <div className={classes.root}>
        <NavDrawer />
        <div className={classes.content}>
          <div className={classes.main}>
            <Typography className={classes.hospitalTitle} variant="h4">
              Base Hospital Management
            </Typography>
            <Button
              variant="contained"
              size="large"
              className={classes.addBtn}
              onClick={() => {
                history.push("/add-new-hospital");
              }}
            >
              Add New
            </Button>
          </div>
          <div className={classes.main}>
            <div
              style={{
                width: "100%",
              }}
            >
              <MuiThemeProvider theme={getMuiTheme()}>
                <MaterialDatatable
                  title={"Base Hospital Management"}
                  data={hospitalArr}
                  columns={columns}
                  options={options}
                />
              </MuiThemeProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Hospitals;
